/**
 * Shared top-right gold luopan for Monthly Consultation PDF headers.
 * Used by Activations, Weeks, Letter, and Trap. Transparent Photoroom PNG —
 * Chromium Print Preview ignores CSS circle clips, so alpha is the clip.
 */

import React from "react";
import activationsLuopan from "../../../../assets/monthly-consultation/pdf/activations-luopan.png";

/**
 * Resolve the webpack URL for the gold Zi Wei Dou Shu luopan.
 *
 * @returns Image URL, or empty string when the module did not yield a path
 */
export function cornerLuopanSrc(): string {
  return typeof activationsLuopan === "string" ? activationsLuopan.trim() : "";
}

/**
 * Absolutely positioned header luopan that bleeds off the top and right
 * page edges. Parent must be `.mc-pdf-corner-luopan-band` (position relative,
 * padding-right so titles do not collide).
 */
export const PdfCornerLuopan: React.FC = () => {
  const src = cornerLuopanSrc();
  if (src.length === 0) {
    return null;
  }
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className="mc-pdf-corner-luopan"
    />
  );
};

export default PdfCornerLuopan;
